export const formatHeat = (value: number): string => {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}w`;
  }
  return `${value}`;
};

export const formatDate = (value: string): string => {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${Number(parts[1])}月${Number(parts[2])}日`;
};

export const formatDateFull = (value: string): string => {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${parts[0]} 年 ${Number(parts[1])} 月 ${Number(parts[2])} 日`;
};

export const stageColor = (stage: string): string => {
  switch (stage) {
    case "发生":
      return "bg-primary-100 text-primary-800 border-primary-200";
    case "发酵":
      return "bg-secondary-100 text-secondary-800 border-secondary-200";
    case "回应":
      return "bg-accent-100 text-accent-800 border-accent-200";
    default:
      return "bg-background-200 text-foreground-700 border-background-300";
  }
};

export const statusColor = (status: string): string => {
  switch (status) {
    case "持续发酵":
      return "bg-primary-500 text-background-50";
    case "已澄清":
      return "bg-accent-500 text-background-50";
    default:
      return "bg-secondary-500 text-foreground-950";
  }
};